export const TRANSACTION = "TRANSACTION";
export const FORM_DATA = "FORM_DATA";
export const TWO_FACTOR = "TWO_FACTOR";
export const TIME_OUT = "TIME_OUT";
export const STAKING = "STAKING";
export const NOTIFICATIONS = "NOTIFICATIONS";
